import { render, staticRenderFns } from "./GerenciamentoServicoListFiltroModalItemInputProduto.vue?vue&type=template&id=ef730eec"
import script from "./GerenciamentoServicoListFiltroModalItemInputProduto.vue?vue&type=script&lang=js"
export * from "./GerenciamentoServicoListFiltroModalItemInputProduto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports